export default __webpack_public_path__ + "static/media/src_img_8.5d05b917.png";